import React, { useEffect, useRef, useState } from "react";
import { deleteLabelApi, deleteLanguageEquivalentApi, fetchErrorLog, getLanguageDataApi } from "utils/apiService";
import Loader from "components/Loader/Loader";
import { Button, Icon, message, Popover, Row, Select, Table, Typography } from "antd";
import "./languages.scss";
import LanguagePageHeader from "./LanguagePageHeader";
import LanguagePageModals from "./LanguagePageModals";
import { useDispatch, useSelector } from 'react-redux'
import { getAllLabelsData } from "actions/MultiLanguageActions";
const { Text } = Typography;
const { Option } = Select;


const MultiLanguage = (props) => {
    const [loading, setLoading] = useState(true);
    const [filteredLabels, setFilteredLabels] = useState([]);
    const [filterLang, setFilterLang] = useState("English");
    const childRef = useRef();
    const dispatch = useDispatch()
    const { MultiLanguageReducer } = useSelector((state) => state);

    const content = (props) => {
        return <div>
            <Button
                onClick={(e) => {
                    childRef.current.toggleDeleteModal("Edit label", props)
                }}>
                <span><Text style={{ color: "#181818" }}>Edit</Text></span>
            </Button>
            <div>
                <Button
                    onClick={(e) => {
                        // childRef.current.toggleDeleteModal("Add Language")
                        deleteLabelApi({
                            requestData: {
                                uuid: props.label_uuid,
                            },
                            resCallback: () => { },
                            res200Callback: (res) => {
                                getAllLabelsData(dispatch)
                                message.success("Label Deleted Successfully");
                                // FetchErrorLogAPI();
                            },
                        });
                    }}>
                    <span>
                        <Text
                            style={{
                                color: "#F5222D",
                            }}>
                            Delete
                        </Text></span>
                </Button>
            </div>
        </div>
    }

    const languageEquivalentContent = (props) => {
        return <div>
            <Button
                onClick={(e) => {
                    childRef.current.toggleDeleteModal("edit_language_equivalent", props)
                }}>
                <span><Text style={{ color: "#181818" }}>Edit</Text></span>
            </Button>
            <div>
                <Button
                    onClick={(e) => {
                        // childRef.current.toggleDeleteModal("Add Language")
                        deleteLanguageEquivalentApi({
                            requestData: {
                                uuid: props.translation_uuid,
                            },
                            resCallback: () => { },
                            res200Callback: (res) => {
                                getAllLabelsData(dispatch)
                                message.success("Language Equivalent Deleted Successfully");
                            },
                        });
                    }}>
                    <span>
                        <Text
                            style={{
                                color: "#F5222D",
                            }}>
                            Delete
                        </Text>
                    </span>
                </Button>
            </div>
        </div>
    }

    const columns = [
        // {
        //     title: 'S. No',
        //     width: 100,
        //     dataIndex: 'keyy',
        //     key: 'keyy',
        //     fixed: 'left',
        // },
        {
            title: 'Label',
            // width: 200,
            dataIndex: 'name',
            key: 'name',
            // fixed: 'left',
        },
        {
            title: '',
            key: 'operation',
            // fixed: 'right',
            width: 100,
            render: (_, row) =>
                <Popover placement="bottomRight" content={content(row)} trigger="hover">
                    <Icon
                        type='more'
                        style={{
                            height: "16px",
                        }}
                    />
                </Popover>
        },
        {
            title: () => {
                return <div>
                    <Select
                        placeholder="Select language"
                        name="language"
                        style={{ width: "200px", marginTop: "4px", borderRadius: "4px", backgroundColor: "#fff", color: "#000" }}
                        value={filterLang}
                        onChange={(value) => {
                            setFilterLang(value)
                        }}
                    >
                        {MultiLanguageReducer?.multiLanguageLabelsList?.languages_data &&
                            Object.keys(MultiLanguageReducer?.multiLanguageLabelsList?.languages_data).map((valuee) => {
                                return (
                                    <Option value={valuee}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {valuee}
                                        </div>
                                    </Option>
                                );
                            })}
                    </Select>
                </div>;
            },
            dataIndex: 'translation_value',
            // key: 'label_value',
            // width: 200
        },
        {
            title: '',
            key: 'operation2',
            // fixed: 'right',
            width: 100,
            render: (_, row) =>
                <Popover placement="bottomRight" content={languageEquivalentContent(row)} trigger="hover">
                    <Icon
                        type='more'
                        style={{
                            height: "16px",
                        }}
                    />
                </Popover>
        },
    ];

    const FilterOnSearch = (SearchKey) => {
        const LabelsList = MultiLanguageReducer?.multiLanguageLabelsList?.languages_data[filterLang]
        const filteredLabelss = SearchKey === "" || !SearchKey ?
            LabelsList :
            LabelsList.filter((label) => {
                return (
                    label.name.includes(SearchKey) || label.translation_value.includes(SearchKey)
                )
            })
        setFilteredLabels(filteredLabelss)
    };

    useEffect(() => {
        getAllLabelsData(dispatch)
    }, []);

    useEffect(() => {
        MultiLanguageReducer?.multiLanguageLabelsList?.languages_data && setLoading(false)
    }, [MultiLanguageReducer?.multiLanguageLabelsList?.languages_data]);

    return loading ? (
        <Row type='flex' align='middle' justify='center' style={{ marginTop: "200px" }}>
            <Loader />
        </Row>
    ) : (
        <Row
            style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "40px 25px 70px",
                margin: "60px auto 20px",
                backgroundColor: "#FAFAFA",
                marginTop: "80px",
            }}
            gutter={[12, 48]}
        >

            <LanguagePageModals ref={childRef} labelList={MultiLanguageReducer?.multiLanguageLabelsList?.languages_data} />

            <LanguagePageHeader FilterOnSearch={FilterOnSearch} />
            {MultiLanguageReducer?.multiLanguageLabelsList?.languages_data && <Table
                columns={(function () {
                    // if (props.noAction) {
                    // 	return columns.filter((item) => item.key != "x");
                    // }
                    return columns;
                })()}
                dataSource={filteredLabels.length > 0 ? filteredLabels : MultiLanguageReducer?.multiLanguageLabelsList?.languages_data[filterLang]}
                // pagination={{
                //     showQuickJumper: true,
                //     //  current: data.pageNum, pageSize: data.pageSize, total: data.pageSize * data.totalPages 
                // }}
                pagination={false}
                style={{ marginTop: "-10px" }}
            // onChange={(pagination) => {
            // 	props.updatePage(pagination.current);
            // }}
            // loading={props.loading}
            />}
            {/* <div style={{ marginTop: "16px", textAlign: "right" }}>
                <Button
                    size="large"
                    style={{
                        height: "40px",
                        borderRadius: "5px",
                        border: "none",
                        backgroundColor: "#FFFFFF",
                        color: "#000",
                        marginRight: "16px",
                        border: "1px solid #D9D9D9"
                    }}
                    onClick={() => {
                     
                    }}>
                    Save Draft
                </Button>
                <Button
                    size="large"
                    style={{
                        height: "40px",
                        borderRadius: "5px",
                        border: "none",
                        backgroundColor: "#2D9140",
                        color: "#FFFFFF",
                    }}
                    onClick={() => {
                       
                    }}>
                    Publish
                </Button>
            </div> */}
        </Row>
    );
};

export default MultiLanguage;
